import styled from 'styled-components'

export const LastPge = styled.div`
  padding: 20px 0;
  color: #acacac;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  &::before,
  &::after {
    content: '';
    display: block;
    flex: 1;
    height: 1px;
    background-color: #ccc;
  }
`
